<template>
  <div>
    <BaseCardV2
      titre="Mes données Agrial"
      :has-btn-action="false"
      :has-eq-height="false"
      class="mb-3"
    >
      <v-row
        no-gutters
        class="ma-4"
      >
        <v-col cols="5">
          <div class="intro texte-gris-fonce">
            Raison sociale
          </div>
        </v-col>

        <v-col
          cols="7"
          class="font-weight-bold"
        >
          <div class="intro secondary--text">
            {{ adherent.raisonSociale }}
          </div>
        </v-col>
      </v-row>
      <v-divider class="mx-4" />
      <v-row
        no-gutters
        class="ma-4"
      >
        <v-col cols="5">
          <div class="intro texte-gris-fonce">
            N° de compte Adhérent
          </div>
        </v-col>
        <v-col
          cols="7"
          class="font-weight-bold"
        >
          <div class="intro secondary--text">
            {{ adherent.numtiers }}
          </div>
        </v-col>
      </v-row>
      <v-divider class="mx-4" />
      <v-row
        no-gutters
        class="ma-4"
      >
        <v-col cols="5">
          <div class="intro texte-gris-fonce">
            Ma région Agrial
          </div>
        </v-col>
        <v-col
          cols="7"
          class="font-weight-bold"
        >
          <div class="intro secondary--text">
            {{ adherent.libelleRegion }}
          </div>
        </v-col>
      </v-row>
    </BaseCardV2>
    <BaseCardV2
      titre="Mes conseillers"
      :has-btn-action="false"
      :has-eq-height="false"
      class="mb-3"
    >
      <v-row
        v-for="(unConseiller, index) in tousConseillers"
        :key="unConseiller.codeConseille"
        no-gutters
        class="pt-4 mx-4"
        :class="index === tousConseillers.length - 1 ? 'pb-4' : ''"
      >
        <v-col
          cols="5"
        >
          <div class="intro texte-gris-fonce">
            {{ Object.values(unConseiller.fonctions)[0] }}
          </div>
        </v-col>
        <v-col
          cols="7"
        >
          <div class="intro secondary--text">
            {{ unConseiller.nom != null ? unConseiller.nom : '-' }}
          </div>
          <div class="texte texte-gris-fonce">
            {{ unConseiller.numTel != null && unConseiller.numTel !== ' ' ? phoneNumberFormatted(unConseiller.numTel) : '-' }}
          </div>
          <div class="texte texte-gris-fonce">
            {{ unConseiller.email != null ? unConseiller.email : '-' }}
          </div>
        </v-col>
        <v-divider
          v-if="index < tousConseillers.length - 1"
          class="mx-1 mt-3"
        />
      </v-row>
    </BaseCardV2>
    <BaseCardV2
      titre="Mes coordonnées"
      :has-btn-action="false"
      :has-eq-height="false"
    >
      <v-row
        no-gutters
        class="pt-4 mx-4"
      >
        <v-col cols="5">
          <div class="intro texte-gris-fonce">
            Adresse
          </div>
        </v-col>
        <v-col
          cols="7"
        >
          <div class="intro secondary--text">
            {{ adherent.coordonnee != null && adherent.coordonnee.adresse != null ? adherent.coordonnee.adresse : '-' }}
          </div>
          <div class="texte texte-gris-fonce">
            {{ adherent.coordonnee != null ? adherent.coordonnee.complementAdresse : '-' }}
          </div>
          <div class="texte texte-gris-fonce">
            {{ adherent.coordonnee != null ? adherent.coordonnee.codePostal : '-' }} {{ adherent.coordonnee != null ? adherent.coordonnee.ville : '' }}
          </div>
        </v-col>
      </v-row>
      <v-divider
        class="mx-3 mt-3"
      />
      <v-row
        no-gutters
        class="pt-4 mx-4"
      >
        <v-col cols="5">
          <div class="intro">
            N° de tel principal de l'exploitation
          </div>
        </v-col>
        <v-col
          cols="7"
        >
          <div class="intro secondary--text">
            {{ adherent.coordonnee != null && adherent.coordonnee.telephoneFixe != null ? phoneNumberFormatted(adherent.coordonnee.telephoneFixe) : '-' }}
          </div>
        </v-col>
      </v-row>
      <v-divider
        class="mx-3 mt-3"
      />
      <v-row
        no-gutters
        class="pt-4 mx-4"
      >
        <v-col cols="5">
          <div class="intro">
            Autre n° de tel de l'exploitation
          </div>
        </v-col>
        <v-col
          v-if="!!adherent.coordonnee"
          cols="7"
        >
          <div class="intro secondary--text">
            {{ adherent.coordonnee != null && adherent.coordonnee.telephonePortable != null ? phoneNumberFormatted(adherent.coordonnee.telephonePortable) : '-' }}
          </div>
        </v-col>
      </v-row>
      <v-divider
        class="mx-3 mt-3"
      />
      <v-row
        no-gutters
        class="py-4 mx-4"
      >
        <v-col cols="5">
          <div class="intro">
            Mail de l'exploitation
          </div>
        </v-col>
        <v-col
          cols="7"
        >
          <div class="intro secondary--text">
            {{ adherent.coordonnee != null && adherent.coordonnee.email ? adherent.coordonnee.email : '-' }}
          </div>
        </v-col>
      </v-row>
    </BaseCardV2>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseCardV2 from '@/components/card/base-card-v2.vue'

export default {
  name: 'InfoAdherent',
  components: { BaseCardV2 },
  props: {
    tousConseillers : {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      ongletSelected: 'conseillers'
    }
  },

  computed: {
    ...mapGetters({
      adherent: 'adherent/adherent'
    })
  },
  methods: {
    phoneNumberFormatted (value) {
      return value.replace(/\B(?=(\d{2})+(?!\d))/g, ' ')
    }
  }
}
 </script>


